<template>
    <div class="chart-container">
      <Pie :data="chartData" :options="chartOptions" />
    </div>
  </template>
  
  <script>
  import { Pie } from "vue-chartjs";
  import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
  
  ChartJS.register(ArcElement, Tooltip, Legend);
  
  export default {
    components: { Pie },
    props: {
      data: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        chartData: this.data,
        chartOptions: {
          responsive: true,
          maintainAspectRatio: false,
        },
      };
    },
    watch: {
      data(newData) {
        this.chartData = newData;
      },
    },
  };
  </script>
  
  <style scoped>
  .chart-container {
    height: 95%;
    width: 100%;
    position: relative;
  }
  </style>
  